<template><div><h1 id="kassen" tabindex="-1"><a class="header-anchor" href="#kassen"><span>Kassen</span></a></h1>
<p>Kassen — Kassen verwalten</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In diesem Frame werden Kassen mit den zugehörigen Einstellungen gepflegt</p>
<p>Pfad: <code v-pre>Verkauf → Tabellen → Kassen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Kasse</dt>
<dd>Kurzbezeichnung der Kasse</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung der Kasse.</dd>
<dt>Auftragsart</dt>
<dd>Jede Kasse muss mit einer <a class="link" href="ft.refdata.tblaufart.html" title="Auftragsart">Auftragsart</a> verknüpft sein. Daraus werden weitere Einstellungen, wie Lager, Verkaufsereignis usw. abgeleitet.</dd>
<dt>Person</dt>
<dd>Verkaufsereignisse und Buchungen werden dieser Person zugeordnet.</dd>
<dt>Lieferart</dt>
<dd>Standardwert der im Kassenauftrag eingetragen wird.</dd>
<dt>Bestellart</dt>
<dd>Standardwert der im Kassenauftrag eingetragen wird..</dd>
<dt>drucken</dt>
<dd>Definiert, ob beim Kassenverkauf die Option für den Belegdruck verwendbar ist oder nicht.</dd>
<dt>Status</dt>
<dd>Nur Kassen mkt Status &quot;aktiv&quot; können eingesetzt werden.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>keine</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.tblaufart.html" title="Auftragsart">Auftragsarten</RouteLink>, <RouteLink to="/manual/trade/kassenverkauf.html" title="7. Kassenverkauf">Kassenverkauf</RouteLink></p>
</div></template>


